import * as React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { SessionManagementService } from '../../../services/SessionManagementService';
import { ListViewStyles } from '../../listView/ListViewStyles';

import { DetailsTooltipStyles } from '../DetailsTooltipStyles';

export interface EntityLinkProps {
  name: string;
  href: string;
  styleOverride?: React.CSSProperties;
}

export function EntityLink(props: EntityLinkProps): JSX.Element {
  const entityLabelElement = props.href ? (
    <a href={props.href} style={{ fontWeight: 'bold' }}>
      {props.name}
    </a>
  ) : (
    <span style={{ fontWeight: 'bold' }}>{props.name}</span>
  );
  return (
    <div className={DetailsTooltipStyles.MetadataLinkValue} style={props.styleOverride}>
      {entityLabelElement}
    </div>
  );
}

export function UserEntityLink(props: EntityLinkProps): JSX.Element {
  return !SessionManagementService.instance.isLimitedUserVisibilityChannel() ? (
    <EntityLink {...props} />
  ) : (
    <span style={ListViewStyles.HiddenUserStyle}>{Messages.hiddenUser()}</span>
  );
}
